"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.FormControl = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _themes = require("../../themes");

var _styles = require("../../helpers/styles");

var _Label = require("../../atoms/Label");

var _Hint = require("../../atoms/Hint");

var _Error = require("../../atoms/Error");

var _HelpText = require("../../atoms/HelpText");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = {
  "form-control": "form-control__form-control___3mHbj",
  "hint": "form-control__hint___2xtWP",
  "label": "form-control__label___1MwGC",
  "large-size": "form-control__large-size___3kPDm"
};

var FormControl = function FormControl(_ref) {
  var children = _ref.children,
      id = _ref.id,
      error = _ref.error,
      errorClassName = _ref.errorClassName,
      label = _ref.label,
      labelClassName = _ref.labelClassName,
      hintText = _ref.hintText,
      helpText = _ref.helpText,
      helpTextClassName = _ref.helpTextClassName,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'm' : _ref$size,
      compileWithTheme = _ref.compileWithTheme;
  return React.createElement("div", {
    className: compileWithTheme((0, _classnames["default"])(styles['form-control'], (0, _styles.getSizeClassName)(styles, size), className))
  }, !!label && React.createElement(_Label.Label, {
    text: label,
    className: (0, _classnames["default"])(styles.label, labelClassName),
    htmlFor: id
  }), hintText && React.createElement(_Hint.Hint, {
    text: hintText,
    className: styles.hint
  }), children && (Array.isArray(children) ? children.map(function (child, index) {
    return React.cloneElement(child, {
      size: size,
      key: index
    });
  }) : React.cloneElement(children, {
    size: size
  })), !!error && React.createElement(_Error.Error, {
    className: errorClassName,
    text: error
  }), !error && helpText && React.createElement(_HelpText.HelpText, {
    className: helpTextClassName,
    text: helpText
  }));
};

exports.FormControl = FormControl;

var _default = (0, _themes.withTheme)(FormControl);

exports["default"] = _default;